'use client'

import { memo } from 'react'

import Image from 'next/image'

import logoIcon from '@images/navbar/logo_main-nav.svg'

import styles from './logo.module.scss'
import Link from 'next/link'

function Logo(): JSX.Element {
  return (
    <Link href="/" className={styles.logo}>
      <Image src={logoIcon} alt="SonicJobs Logo" width={131} height={33} />
    </Link>
  )
}

export default memo(Logo)
